import React, { useId } from "react";
import { SF009_TIME_SLOT_OPTIONS, normalizeSf009Time } from "./sf009FormSignatureUtils";

const inputStyle = {
  width: "100%",
  minWidth: 88,
  border: "none",
  outline: "none",
  fontSize: 11,
  lineHeight: 1.35,
  padding: "4px 4px",
  background: "transparent",
  boxSizing: "border-box",
  fontFamily: "inherit",
  color: "#1a202c",
};

export default function Sf009TimeSelect({ value, onChange }) {
  const listId = useId();
  const v = normalizeSf009Time(value);

  return (
    <>
      <input
        type="text"
        list={listId}
        value={v}
        onChange={(e) => onChange(normalizeSf009Time(e.target.value))}
        onBlur={(e) => onChange(normalizeSf009Time(e.target.value))}
        placeholder="HH:MM AM"
        style={inputStyle}
        autoComplete="off"
        spellCheck={false}
      />
      <datalist id={listId}>
        {SF009_TIME_SLOT_OPTIONS.map((t) => (
          <option key={t} value={t} />
        ))}
      </datalist>
    </>
  );
}
